// extracted by mini-css-extract-plugin
export default {"BP2k":"2100px","BPmobile":"800px","giganticDesktop":"2100px","largeDesktop":"1600px","mediumDesktop":"1300px","smallDesktop":"950px","mobile":"600px","keepNavigatorOpen":"1800px"};